import React from 'react'

import { Select as DefaultSelect } from 'components'
import { INPUT } from 'components/AuthModal/styles'

const Select = ({ options, value, labelPrefix, selectedLabel, defaultLabel, ...rest }) => {
  const SelectOption = ({ label, value = '', disabled }) => (
    <option disabled={disabled} value={value} className="bg-midnightBlack text-left text-white">
      {label}
    </option>
  )

  const selectedOption = options.find(option => option.value === value)

  return (
    <div className="w-full relative bg-woodsmokeBlack rounded-full">
      <div
        className="absolute top-1/2 transform -translate-y-1/2 flex items-center text-white z-10 text-base pl-6"
        style={{
          width: 'calc(100% - 60px)',
        }}
      >
        {selectedLabel || selectedOption?.label || defaultLabel}
      </div>
      <DefaultSelect
        styles={{ select: { fontWeight: 'normal', opacity: 0 } }}
        classNames={{
          label: 'w-full font-normal relative z-50',
          labelText: 'font-tomatoGrotesk-reg font-normal opacity-0',
          select: `text-black ${INPUT} text-opacity-0 border-none z-50`,
          chevron: 'right-9 w-4 h-4',
        }}
        value={value}
        {...rest}
      >
        <SelectOption label={defaultLabel} value="" />
        {options.map(({ value, label }) => (
          <SelectOption key={value} value={value} label={label} />
        ))}
      </DefaultSelect>
    </div>
  )
}

export default Select
